import type { ExpenseItem } from '../types/ExpenseItem';

export const normalizeExpenseItems = (value: unknown): ExpenseItem[] => {
  if (!Array.isArray(value)) throw new Error('Expense items must be a list.');
  return value.map((item: unknown, index) => {
    if (!item || typeof item !== 'object' || Array.isArray(item)
      || !('name' in item) || typeof item.name !== 'string' || !('amount' in item)) {
      throw new Error(`Expense item ${index + 1} is invalid.`);
    }
    const raw = item.amount;
    const amount = typeof raw === 'number' ? raw
      : typeof raw === 'string' && /^[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?$/.test(raw.trim())
        ? Number(raw) : NaN;
    if (!Number.isFinite(amount)) throw new Error(`Expense item ${index + 1} has an invalid amount.`);
    return { ...item, name: item.name, amount };
  });
};
